import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

import { DataInAnyRow } from "components/PageDashboard/ExternalCommitmentsSection/ExternalCommitmentsTable/ExternalCommitmentsTable";
import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";
import FieldHourOfDay from "components/FieldHourOfDay";
import { isInteger } from "utils/isInteger";

function StepTime({
	enableProgressToNextStep,
	disableProgressToNextStep,
	wizardData,
	wizardKey,
	checkDisabled = () => false
}: ModalWizardStepRenderProps<DataInAnyRow> & {
	wizardKey: keyof typeof wizardData;
	checkDisabled?: (time: number) => boolean;
}) {
	const [selectedTime, setSelectedTime] = useState<number | undefined>();

	useEffect(() => {
		if (selectedTime === undefined) {
			disableProgressToNextStep();
			return;
		}
		if (isNaN(selectedTime)) {
			disableProgressToNextStep();
			return;
		}
		if (!isInteger(selectedTime)) {
			disableProgressToNextStep();
			return;
		}

		enableProgressToNextStep({
			[wizardKey]: moment.duration(selectedTime, "hours")
		});
	}, [
		enableProgressToNextStep,
		disableProgressToNextStep,
		selectedTime,
		wizardKey
	]);

	return (
		<FieldHourOfDay
			selectedTime={selectedTime}
			onChange={setSelectedTime}
			isDisabled={checkDisabled}
		/>
	);
}

export default StepTime;
